'use no memo';

import { createFileRoute } from '@tanstack/react-router';
import { zodValidator } from '@tanstack/zod-adapter';
import ImportCsv from '@/features/import-csv';
import type { ExportApiUrl } from '@/features/import-csv/types';
import { ImportCsvSearchSchema } from '@/features/import-csv/zod-schemas';
import useDevelopmentTicketTableRows from './-hooks/useDevelopmentTicketTableRows';

/**
 * 開発チケット一覧 CSV 一括取り込み画面 (/development-tickets/import-csv)。
 *
 * 不具合 (Issue) の `/issues/import-csv` を踏襲した薄いラッパー。
 * 共通 `ImportCsv` feature に Ticket 用の export URL / hook を渡すだけ。
 *
 * テキスト類は MVP 段階のためハードコード。i18n キー化は別タスクで対応する。
 */
const DevelopmentTicketImportCsv = () => {
  const search = Route.useSearch();
  const navigate = Route.useNavigate();
  const exportApiUrl: ExportApiUrl = '/v2/pn-force/tickets/csv';
  return <ImportCsv baseLink="/development-tickets/import-csv" baseTitle="開発チケットをCSVで追加" exportApiUrl={exportApiUrl} exportFilename="ticket-list" templateMessage={{
    templateTitle: 'テンプレートをダウンロード',
    updateExisting: '既存データを編集',
    completeLinkButton: '開発チケット一覧に戻る'
  }} completeLinkUrl="/development-tickets" unit="件" search={search} navigate={navigate} useTableRows={useDevelopmentTicketTableRows} />;
};
export const Route = createFileRoute('/_stacktrace/development-tickets/import-csv')({
  validateSearch: zodValidator(ImportCsvSearchSchema),
  component: DevelopmentTicketImportCsv
});